/** @format */

import React from "react"
import { Link } from "react-router-dom"
import "./LegalPage.css"

function OfferPage() {
    return (
        <main className="legal-page">
            <div className="container legal-container">
                <div className="legal-card">
                    <h1 className="font-display">Договор-оферта</h1>
                    <p className="legal-date">Дата публикации: 18 февраля 2026 г.</p>

                    <p>
                        Настоящий документ является публичной офертой ИП [ФИО], ИНН [номер], ОГРНИП [номер]
                        (далее — «Исполнитель») и содержит условия предоставления услуг по краткосрочной
                        аренде загородного дома «Лесной домик» (далее — «Объект»).
                    </p>
                    <p>
                        В соответствии со ст. 437 Гражданского кодекса РФ данный документ является публичной
                        офертой, адресованной неопределённому кругу лиц. Акцептом оферты является оформление
                        бронирования и внесение предоплаты.
                    </p>

                    <h2>1. Термины и определения</h2>
                    <p>
                        <strong>Исполнитель</strong> — ИП [ФИО], предоставляющий Объект в аренду.
                    </p>
                    <p>
                        <strong>Заказчик</strong> — физическое лицо, оформившее бронирование на Сайте.
                    </p>
                    <p>
                        <strong>Объект</strong> — загородный дом «Лесной домик» с прилегающей территорией.
                    </p>
                    <p>
                        <strong>Бронирование</strong> — заявка Заказчика на аренду Объекта в указанные даты.
                    </p>
                    <p>
                        <strong>Сайт</strong> — интернет-ресурс Исполнителя, на котором осуществляется
                        бронирование.
                    </p>

                    <h2>2. Предмет договора</h2>
                    <p>
                        2.1. Исполнитель обязуется предоставить Заказчику во временное пользование Объект на
                        период, указанный в бронировании, а Заказчик обязуется оплатить услуги в порядке и на
                        условиях, предусмотренных настоящим договором.
                    </p>
                    <p>
                        2.2. Объект предоставляется для проживания и проведения мероприятий. Максимальное
                        количество гостей определяется настройками Сайта и указывается при бронировании.
                    </p>

                    <h2>3. Порядок бронирования</h2>
                    <p>3.1. Заказчик выбирает даты заезда и выезда в календаре на Сайте.</p>
                    <p>
                        3.2. Заказчик заполняет форму бронирования: имя, номер телефона, количество гостей и
                        при необходимости оставляет комментарий.
                    </p>
                    <p>
                        3.3. После заполнения формы Заказчик подтверждает согласие с настоящим
                        Договором-офертой и Политикой конфиденциальности.
                    </p>
                    <p>3.4. Бронирование считается подтверждённым после внесения предоплаты.</p>

                    <h2>4. Стоимость и порядок оплаты</h2>
                    <p>
                        4.1. Стоимость аренды рассчитывается автоматически на основании: базовой цены за
                        сутки, количества суток проживания и надбавки за дополнительных гостей сверх
                        включённого количества.
                    </p>
                    <p>
                        4.2. Актуальные цены указаны на Сайте и могут быть изменены Исполнителем в
                        одностороннем порядке. Цена, зафиксированная на момент оформления бронирования,
                        изменению не подлежит.
                    </p>
                    <p>
                        4.3. При бронировании Заказчик вносит предоплату в размере, указанном на Сайте
                        (процент от общей стоимости). Оставшаяся сумма оплачивается в день заезда.
                    </p>
                    <p>
                        4.4. Оплата производится банковской картой через платёжный сервис ЮKassa (ООО
                        «ЮМани»). Исполнитель не получает и не хранит данные банковских карт Заказчика.
                    </p>

                    <h2>5. Условия отмены и возврата</h2>
                    <p>5.1. Заказчик вправе отменить бронирование:</p>
                    <ul>
                        <li>
                            <strong>За 7 и более дней до даты заезда</strong> — предоплата возвращается в
                            полном объёме.
                        </li>
                        <li>
                            <strong>От 3 до 6 дней до даты заезда</strong> — возвращается 50% предоплаты.
                        </li>
                        <li>
                            <strong>Менее 3 дней до даты заезда</strong> — предоплата не возвращается.
                        </li>
                    </ul>
                    <p>
                        5.2. Для отмены бронирования Заказчик обращается к Исполнителю по телефону или
                        электронной почте.
                    </p>
                    <p>
                        5.3. Возврат денежных средств осуществляется тем же способом, которым была произведена
                        оплата, в течение 10 рабочих дней с момента подтверждения отмены.
                    </p>
                    <p>
                        5.4. Исполнитель вправе отменить бронирование по причине форс-мажорных обстоятельств с
                        полным возвратом предоплаты.
                    </p>

                    <h2>6. Права и обязанности сторон</h2>
                    <h3>6.1. Исполнитель обязан:</h3>
                    <ul>
                        <li>Предоставить Объект в состоянии, пригодном для проживания</li>
                        <li>Обеспечить заявленные условия и удобства</li>
                        <li>Своевременно информировать Заказчика об изменениях</li>
                    </ul>
                    <h3>6.2. Заказчик обязан:</h3>
                    <ul>
                        <li>Своевременно произвести оплату</li>
                        <li>Бережно относиться к имуществу Объекта</li>
                        <li>Соблюдать правила пользования Объектом</li>
                        <li>Не превышать заявленное количество гостей</li>
                        <li>Оставить Объект в надлежащем состоянии при выезде</li>
                    </ul>

                    <h2>7. Ответственность сторон</h2>
                    <p>
                        7.1. Заказчик несёт материальную ответственность за ущерб, причинённый имуществу
                        Объекта в период проживания.
                    </p>
                    <p>
                        7.2. Исполнитель не несёт ответственности за ущерб, причинённый здоровью или имуществу
                        Заказчика и его гостей вследствие нарушения ими правил безопасности.
                    </p>
                    <p>
                        7.3. Стороны освобождаются от ответственности за неисполнение обязательств в случае
                        форс-мажорных обстоятельств.
                    </p>

                    <h2>8. Порядок разрешения споров</h2>
                    <p>
                        8.1. Все споры решаются путём переговоров. При невозможности достижения соглашения
                        спор передаётся на рассмотрение в суд по месту нахождения Исполнителя в соответствии с
                        законодательством РФ.
                    </p>

                    <h2>9. Срок действия</h2>
                    <p>
                        9.1. Настоящий Договор-оферта действует с момента размещения на Сайте и до его отзыва
                        Исполнителем.
                    </p>
                    <p>
                        9.2. Исполнитель вправе в одностороннем порядке изменять условия настоящего Договора.
                        Изменения вступают в силу с момента публикации на Сайте. Бронирования, оформленные до
                        внесения изменений, исполняются на прежних условиях.
                    </p>

                    <h2>10. Реквизиты Исполнителя</h2>
                    <ul>
                        <li>ИП [ФИО]</li>
                        <li>ИНН: [номер]</li>
                        <li>ОГРНИП: [номер]</li>
                        <li>Адрес: [юридический адрес]</li>
                        <li>
                            Телефон: <a href="tel:+79153663735">+7 915 366 37 35</a>
                        </li>
                        <li>
                            Email: <a href="mailto:matinyan.lilit@mail.ru">matinyan.lilit@mail.ru</a>
                        </li>
                    </ul>

                    <Link to="/" className="btn-outline legal-back">
                        ← На главную
                    </Link>
                </div>
            </div>
        </main>
    )
}

export default OfferPage
